import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class UserManagementService {

  constructor(private http: HttpClient) { }

  getActivityLogs(params) {
    const url = '/dashboard/v1/hansel/user-logs/query';

    return this.http.post<any>(url, params).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  getUsers(params?) {
    const url = '/dashboard/getusersofcompany';
    return this.http.get<any>(url, { 'params': params }).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  inviteUsers(payload) {
    const url = '/dashboard/inviteuserstocompany';
    payload['dashboard_version'] = '3.0';
    if (payload.resendInvite) {
      payload['resend_email'] = 1;
    }

    return this.http.post<any>(url, payload).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  deleteUser(uid) {
    const url = '/dashboard/deleteuser?user_id=' + uid;
    return this.http.delete<any>(url).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }
}
